export default "__VITE_ASSET__Bh8EpE_e__"